import { guardToolAction } from "./toolActionGuard.js";
/**
 * Executes a simulated dry run on a tool action, returning safety guard results and simulated previews.
 */
export function createToolDryRun(tool, actionId, _input) {
    const guard = guardToolAction(tool, actionId);
    const toolId = tool?.toolId || tool?.integrationId || "unknown";
    const preview_hi = guard.ok
        ? `[सिम्युलेटेड ड्राई-रन पूर्वावलोकन] टूल '${toolId}' पर '${actionId}' क्रिया का सुरक्षित परीक्षण पूर्ण।`
        : `[अवरुद्ध पूर्वावलोकन] '${actionId}' क्रिया सुरक्षा मानदंडों के उल्लंघन के कारण अवरुद्ध है। कारण: ${guard.reason_hi}`;
    return {
        ok: guard.ok,
        mode: "dry_run",
        toolId,
        actionId,
        preview_hi,
        blocked: !guard.ok || guard.status === "blocked" || guard.status === "unknown_action",
        requiresConfirmation: guard.status === "confirmation_required",
        guard
    };
}
/**
 * Returns a simulated markdown description of what the action would execute.
 */
export function createToolRuntimePreview(tool, actionId) {
    const run = createToolDryRun(tool, actionId);
    return run.preview_hi || "";
}
//# sourceMappingURL=toolDryRun.js.map